import { FC, useMemo, useState } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useModal } from 'core'
import { computeDesigner } from 'shared/helpers/computeData'
import { DesignerCardNew } from 'shared/components/designerCard/designerCard'
import { SearchIcon, CloseIcon } from 'shared/icons'
import {
    Wrapper,
    Title,
    SearchRow,
    SearchBox,
    SearchInputEl,
    ClearButton,
    FindButton,
    ScrollArea,
    EmptyState,
    FooterRow,
    Grid,
} from './styles'

interface AddGroupTeachersModalProps {
    groupCode?: string
    pool?: any[]
    selectedIds?: string[]
    onConfirm?: (selected: any[]) => void
}

export const AddGroupTeachersModal: FC<AddGroupTeachersModalProps> = ({
    groupCode = '',
    pool = [],
    selectedIds = [],
    onConfirm,
}) => {
    const modal = useModal()

    const [searchInput, setSearchInput] = useState('')
    const [appliedQuery, setAppliedQuery] = useState('')
    const [selected, setSelected] = useState<Set<string>>(() => new Set(selectedIds))

    const computedPool = useMemo(
        () => pool.map(item => ({ raw: item, computed: computeDesigner(item) })),
        [pool]
    )

    const filtered = useMemo(() => {
        const q = appliedQuery.trim().toLowerCase()
        if (!q) return computedPool
        return computedPool.filter(({ computed }) => {
            const full = `${computed.name || ''} ${computed.surName || ''}`.toLowerCase()
            return full.includes(q)
        })
    }, [computedPool, appliedQuery])

    const toggle = (accountId: string) => {
        setSelected(prev => {
            const next = new Set(prev)
            if (next.has(accountId)) next.delete(accountId)
            else next.add(accountId)
            return next
        })
    }

    const applySearch = () => setAppliedQuery(searchInput)

    const clearSearch = () => {
        setSearchInput('')
        setAppliedQuery('')
    }

    const handleSave = () => {
        const picked = pool.filter(item => selected.has(item.accountId || item.designerId))
        onConfirm?.(picked)
        modal.hide()
    }

    return (
        <Wrapper>
            <Title>{`Преподаватели группы ${groupCode || ''}`.trim()}</Title>

            <SearchRow>
                <SearchBox>
                    <SearchIcon />
                    <SearchInputEl
                        placeholder="Поиск по имени"
                        value={searchInput}
                        onChange={e => setSearchInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') applySearch()
                        }}
                    />
                    {!!searchInput && (
                        <ClearButton onClick={clearSearch} type="button" aria-label="Очистить">
                            <CloseIcon />
                        </ClearButton>
                    )}
                </SearchBox>
                <FindButton onClick={applySearch} type="button">Найти</FindButton>
            </SearchRow>

            <ScrollArea>
                {filtered.length === 0 ? (
                    <EmptyState>Никого не найдено</EmptyState>
                ) : (
                    <Grid>
                        {filtered.map(({ raw, computed }) => {
                            const { key: _key, ...cardProps } = computed
                            const itemId = raw.accountId || raw.designerId
                            return (
                                <DesignerCardNew
                                    key={itemId || computed.identifier}
                                    {...cardProps}
                                    identifier={itemId}
                                    isSelectable
                                    selected={selected.has(itemId)}
                                    onSelect={toggle}
                                />
                            )
                        })}
                    </Grid>
                )}
            </ScrollArea>

            <FooterRow>
                <BrgButton variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
                    Отмена
                </BrgButton>
                <BrgButton variant={ButtonVariant.Filled} onClick={handleSave}>
                    Сохранить
                </BrgButton>
            </FooterRow>
        </Wrapper>
    )
}
import { FC, useMemo, useState } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useModal } from 'core'
import { computeDesigner } from 'shared/helpers/computeData'
import { DesignerCardNew } from 'shared/components/designerCard/designerCard'
import { SearchIcon, CloseIcon } from 'shared/icons'
import {
    Wrapper,
    Title,
    SearchRow,
    SearchBox,
    SearchInputEl,
    ClearButton,
    FindButton,
    ScrollArea,
    EmptyState,
    FooterRow,
    Grid,
} from './styles'

interface AddGroupTeachersModalProps {
    groupCode?: string
    pool?: any[]
    selectedIds?: string[]
    onConfirm?: (selected: any[]) => void
}

export const AddGroupTeachersModal: FC<AddGroupTeachersModalProps> = ({
    groupCode = '',
    pool = [],
    selectedIds = [],
    onConfirm,
}) => {
    const modal = useModal()

    const [searchInput, setSearchInput] = useState('')
    const [appliedQuery, setAppliedQuery] = useState('')
    const [selected, setSelected] = useState<Set<string>>(() => new Set(selectedIds))

    const computedPool = useMemo(
        () => pool.map(item => ({ raw: item, computed: computeDesigner(item) })),
        [pool]
    )

    const filtered = useMemo(() => {
        const q = appliedQuery.trim().toLowerCase()
        if (!q) return computedPool
        return computedPool.filter(({ computed }) => {
            const full = `${computed.name || ''} ${computed.surName || ''}`.toLowerCase()
            return full.includes(q)
        })
    }, [computedPool, appliedQuery])

    const toggle = (accountId: string) => {
        setSelected(prev => {
            const next = new Set(prev)
            if (next.has(accountId)) next.delete(accountId)
            else next.add(accountId)
            return next
        })
    }

    const applySearch = () => setAppliedQuery(searchInput)

    const clearSearch = () => {
        setSearchInput('')
        setAppliedQuery('')
    }

    const handleSave = () => {
        const picked = pool.filter(item => selected.has(item.accountId || item.designerId))
        onConfirm?.(picked)
        modal.hide()
    }

    return (
        <Wrapper>
            <Title>{`Преподаватели группы ${groupCode || ''}`.trim()}</Title>

            <SearchRow>
                <SearchBox>
                    <SearchIcon />
                    <SearchInputEl
                        placeholder="Поиск по имени"
                        value={searchInput}
                        onChange={e => setSearchInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') applySearch()
                        }}
                    />
                    {!!searchInput && (
                        <ClearButton onClick={clearSearch} type="button" aria-label="Очистить">
                            <CloseIcon />
                        </ClearButton>
                    )}
                </SearchBox>
                <FindButton onClick={applySearch} type="button">Найти</FindButton>
            </SearchRow>

            <ScrollArea>
                {filtered.length === 0 ? (
                    <EmptyState>Никого не найдено</EmptyState>
                ) : (
                    <Grid>
                        {filtered.map(({ raw, computed }) => {
                            const { key: _key, ...cardProps } = computed
                            const itemId = raw.accountId || raw.designerId
                            return (
                                <DesignerCardNew
                                    key={itemId || computed.identifier}
                                    {...cardProps}
                                    identifier={itemId}
                                    isSelectable
                                    selected={selected.has(itemId)}
                                    onSelect={toggle}
                                />
                            )
                        })}
                    </Grid>
                )}
            </ScrollArea>

            <FooterRow>
                <BrgButton variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
                    Отмена
                </BrgButton>
                <BrgButton variant={ButtonVariant.Filled} onClick={handleSave}>
                    Сохранить
                </BrgButton>
            </FooterRow>
        </Wrapper>
    )
}
